import React from 'react';

const Backend = () => (
  <div className="skills_content">
    <h2 className="skills_title">
      Backend Developer
    </h2>

    <div className="skills_box">
      <div className="skills_group">
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name">Ruby</h3>
            <span className="skills_level">Intermediate</span>
          </div>
        </div>
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name">Ruby on Rails</h3>
            <span className="skills_level">Intermediate</span>
          </div>
        </div>
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name">Databases</h3>
            <span className="skills_level">Intermediate</span>
          </div>
        </div>
      </div>
      <div className="skills_group">
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name">Postgresql</h3>
            <span className="skills_level">Intermediate</span>
          </div>
        </div>
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name">Kanban</h3>
            <span className="skills_level">Intermediate</span>
          </div>
        </div>
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name">Googling</h3>
            <span className="skills_level">Advance</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Backend;
